import { DEFAULT_LOGO } from "../utilities/constants"
import { BRAND_SOURCE, resolveEffectiveBrand } from "../data-utils/partnerBranding"

// Returns the effective logo URL for the app shell, applying the CT-1163 brand
// precedence: the child's OWN brand › the inherited managing-partner brand ›
// the ChaosTrack default. `isCustomLogo` distinguishes an org- or partner-uploaded
// logo (rendered on a chip, since uploads often have opaque backgrounds) from the
// transparent default (flush). `brandSource` exposes which brand is in effect.
export const useOrgBranding = (org) => {
  const { source, logoURL } = resolveEffectiveBrand(org)
  const isCustomLogo = !!(logoURL && String(logoURL).trim()) && source !== BRAND_SOURCE.CHAOSTRACK
  return { logoUrl: isCustomLogo ? logoURL : DEFAULT_LOGO, isCustomLogo, brandSource: source }
}
